import "./styles.scss"
import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { Route, Routes } from "react-router-dom"
import { ERoutes } from "../../utils/url"
import { SuppressionListContext } from "./context"
import SuppressionListing from "./containers/listing"

export default function SuppressionList() {

    return (
        <ContentSectionContainer className="suppressionListContainer">
            <SuppressionListContext.Provider value={{}}>
                <Routes>
                    <Route index path={fetchRoute({ route: ERoutes.suppressionList })} element={<SuppressionListing />} />
                    <Route index path={"/"} element={<SuppressionListing />} />
                </Routes>
            </SuppressionListContext.Provider>
        </ContentSectionContainer>
    )
}